module.exports = __webpack_public_path__ + "static/media/atrium-5.cad6dddd.jpg";